type FlowSpecTriggerMatchable = {
  triggerFilter?: { trigger?: Array<{ eventType?: string }> };
};

/** Raw FindingKind / eventType values from a flow spec's trigger filter. */
export function getFindingKindsFromFlowSpec(flowSpec: FlowSpecTriggerMatchable): string[] {
  const triggers = flowSpec.triggerFilter?.trigger ?? [];
  const kinds = triggers
    .map((trigger) => trigger.eventType)
    .filter((eventType): eventType is string => typeof eventType === 'string' && eventType.length > 0);
  return [...new Set(kinds)];
}

export function flowSpecMatchesFindingKind(flowSpec: FlowSpecTriggerMatchable, findingKind: string | undefined): boolean {
  if (!findingKind) {
    return true;
  }
  return getFindingKindsFromFlowSpec(flowSpec).includes(findingKind);
}

export function formatFindingKindsForDisplay(
  flowSpec: FlowSpecTriggerMatchable,
  formatDisplayLabel: (value: string | null | undefined) => string,
): string {
  const kinds = getFindingKindsFromFlowSpec(flowSpec);
  if (kinds.length === 0) {
    return '-';
  }
  return kinds.map((kind) => formatDisplayLabel(kind.toLowerCase())).join(', ');
}
